<script setup lang="ts">
import VIcon from "@verbleif/lib/src/components/Icon/VIcon.vue";
import { onMounted, ref } from "vue";

type ToastIconType = "success" | "info" | "warning" | "error" | "loading";

const { type } = defineProps<{ type: ToastIconType }>();

const ICONS = {
  success: "check",
  info: "info",
  warning: "triangle-alert",
  error: "circle-alert",
  loading: "loader-circle",
} as const;

// vue-sonner puts no role on a toast, so the icon sets it on the toast it sits in: alert for the types that
// interrupt (warning, error), status for the rest.
const ROLES: Record<ToastIconType, "alert" | "status"> = {
  success: "status",
  info: "status",
  warning: "alert",
  error: "alert",
  loading: "status",
};

const root = ref<HTMLElement | null>(null);

onMounted(() => {
  root.value?.closest("[data-sonner-toast]")?.setAttribute("role", ROLES[type]);
});
</script>

<template>
  <span ref="root" style="display: contents">
    <VIcon :name="ICONS[type]" :spin="type === 'loading'" aria-hidden="true" />
  </span>
</template>
